import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @file HoverTrigger
 */
import { Trigger } from './Trigger';
export var HoverTrigger = /*#__PURE__*/function (_Trigger) {
  _inherits(HoverTrigger, _Trigger);

  var _super = _createSuper(HoverTrigger);

  function HoverTrigger() {
    var _this;

    _classCallCheck(this, HoverTrigger);

    _this = _super.apply(this, arguments);
    _this.showDelay = 0;
    _this.hideDelay = 300;
    _this.showTimer = 0;
    _this.hideTimer = 0;
    return _this;
  }

  _createClass(HoverTrigger, [{
    key: "updateHoverTriggerOptions",
    value: function updateHoverTriggerOptions(options) {
      var _options$showDelay = options.showDelay,
          showDelay = _options$showDelay === void 0 ? 0 : _options$showDelay,
          _options$hideDelay = options.hideDelay,
          hideDelay = _options$hideDelay === void 0 ? 300 : _options$hideDelay;
      this.showDelay = showDelay;
      this.hideDelay = hideDelay;
    }
  }, {
    key: "showPopper",
    value: function showPopper() {
      var _this2 = this;

      if (this.disabled) {
        return;
      }

      this.hideAbort();

      var handler = function handler() {
        _this2.showAbort();

        if (_this2.triggerGroup) {
          _this2.triggerGroup.setActiveTrigger(_this2.id);
        }

        _this2.popper.showPopper(_this2.id);
      };

      this.showTimer = Number(setTimeout(handler, this.showDelay));
    }
  }, {
    key: "hidePopper",
    value: function hidePopper() {
      var _this3 = this;

      if (this.disabled) {
        return;
      }

      this.showAbort();

      var handler = function handler() {
        _this3.hideAbort();

        if (_this3.triggerGroup && _this3.id === _this3.triggerGroup.getActiveTrigger()) {
          _this3.triggerGroup.cancelActiveTrigger(_this3.id);

          _this3.popper.hidePopper(_this3.id);
        } else {
          _this3.popper.hidePopper(_this3.id);
        }
      };

      this.hideTimer = Number(setTimeout(handler, this.hideDelay));
    }
  }, {
    key: "showAbort",
    value: function showAbort() {
      clearTimeout(this.showTimer);
      this.showTimer = 0;
    }
  }, {
    key: "hideAbort",
    value: function hideAbort() {
      clearTimeout(this.hideTimer);
      this.hideTimer = 0;
    }
  }]);

  return HoverTrigger;
}(Trigger);